import React from 'react';

export const AdultsOnlyNormalPositionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.52005 47.16C10.1931 47.16 12.3601 44.993 12.3601 42.32C12.3601 39.6469 10.1931 37.48 7.52005 37.48C4.847 37.48 2.68005 39.6469 2.68005 42.32C2.68005 44.993 4.847 47.16 7.52005 47.16Z"
        fill="#FF6AA0"
      />
      <path
        d="M12.36 26.84C15.0331 26.84 17.2 24.6731 17.2 22C17.2 19.327 15.0331 17.16 12.36 17.16C9.68696 17.16 7.52002 19.327 7.52002 22C7.52002 24.6731 9.68696 26.84 12.36 26.84Z"
        fill="#00A6ED"
      />
      <path
        d="M41.16 24.5C39.02 26.1 37.88 28.94 37.68 32.6C34.36 27.16 31.08 23.6 21.94 22.66C21.56 22.6 21.44 22.04 21.8 21.86C28.94 17.74 36.02 19.6 41.16 24.5Z"
        fill="#00A6ED"
      />
      <path
        d="M45.72 39.32C45.34 40.52 44.74 41.6 43.98 42.54C43.3 41.8 42.68 41 42.14 40.14C40.78 37.98 39.66 35.98 38.6 34.16C38.78 31.26 38.6 27.98 40.92 25.76C41.18 25.5 41.46 25.26 41.74 25.08C43.3 26.68 44.64 28.54 45.76 30.6C45.86 30.78 45.96 30.96 46.04 31.14C46.06 31.2 46.06 31.28 46.06 31.34C46.24 33.78 46.64 36.54 45.72 39.32Z"
        fill="#00A6ED"
      />
      <path
        d="M61.4001 45.9001C55.8401 49.2601 49.1201 47.52 44.6801 43.26C45.5601 42.2 46.2401 41 46.6601 39.64C47.3601 37.42 47.3601 35.3 47.1601 33.3C50.3001 39.2 53.2001 43.72 61.1401 44.34C61.9201 44.4401 62.1001 45.5601 61.4001 45.9001Z"
        fill="#00A6ED"
      />
      <path
        d="M56.56 28.64C53.24 28.94 49.9 28.74 46.86 29.58C46.06 29.84 45.9 30.24 45.9 30.24C45.9 30.24 46.02 30.42 46.04 31.14C46.06 31.2 46.06 31.28 46.06 31.34C46.24 33.78 46.64 36.54 45.72 39.32C45.34 40.52 44.74 41.6 43.98 42.54C41.54 45.58 37.44 47.24 33.62 47.02C30.26 46.7 28.04 45.34 26.42 44.8C22.68 43.2 18.9 45.44 15.3 47.26C14.96 47.46 14.54 47.06 14.72 46.72C16.88 41.96 22.04 37.62 27.66 38.54C30.64 38.76 33.08 40.18 35.7 38.96C36.84 38.42 37.76 37.9 38.2 36.8C38.44 36 38.54 35.1 38.6 34.16C38.78 31.26 38.6 27.98 40.92 25.76C41.18 25.5 41.46 25.26 41.74 25.08C44.2 23.3 47.5 23.6 50.16 24.3C51.44 24.66 59.96 27.22 56.56 28.64Z"
        fill="#FF6AA0"
      />
    </svg>
  );
};
